import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05661388"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_chat"
};
const _hoisted_2 = {
  class: "top_cont"
};
const _hoisted_3 = {
  class: "_lefts"
};
const _hoisted_4 = {
  class: "_chats"
};
const _hoisted_5 = ["onMouseover", "onMouseleave"];
const _hoisted_6 = {
  class: "user_items"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "item_name"
};
const _hoisted_9 = {
  class: "item_time"
};
const _hoisted_10 = {
  class: "chat_content"
};
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = ["onClick"];
import item_user from "../../../../assets/user.png";
import { getsearch_cont, getgroup_info, getlocation_list } from "@/service/modules/alllist";
import protoPagination from "@/components/proto-pagination.vue";
import { ref, watch, computed } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'right-chat',
  props: {
    activeName: {
      type: Number,
      default: 1
    },
    selectedDateRange: {
      type: Array,
      default: () => []
    },
    search: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const page = ref({
      page: 1,
      pageSize: 10
    });
    const roleListTotal = ref(0);
    const loading = ref(false);
    const data_list = ref([]);
    const msgtype = ref("");
    const dialogVisible = ref(false);
    const searchParams = computed(() => ({
      search: props.search,
      begin_time: props.selectedDateRange[0] || "",
      end_time: props.selectedDateRange[1] || ""
    }));
    watch(searchParams, () => {
      page.value.page = 1;
      get_list();
    });
    const item_chats = ref("");
    const get_message = item => {
      try {
        const messages = JSON.parse(item.content);
        return item.msgtype === "text" ? messages.content : "";
      } catch (error) {
        console.error("解析消息内容失败:", error);
        return "";
      }
    };
    function handleRoleTableCurrentChange(val) {
      page.value.page = val;
      get_list();
    }
    watch(() => props.activeName, newValue => {
      page.value.page = 1;
      msgtype.value = newValue === 1 ? "" : newValue === 2 ? "image,video" : newValue === 3 ? "file" : newValue === 4 ? "link" : newValue === 5 ? "voice" : "";
      get_list();
    });
    const get_list = async () => {
      loading.value = true;
      try {
        const res = await getsearch_cont({
          search: props.search,
          page: page.value.page,
          pageSize: page.value.pageSize,
          msgtype: msgtype.value,
          begin_time: props.selectedDateRange[0] || "",
          end_time: props.selectedDateRange[1] || ""
        });
        if (res.code === 0) {
          data_list.value = res.data.data.map(item => ({
            ...item,
            hover: false
          }));
          roleListTotal.value = res.data.total;
        } else {
          console.error("请求失败:", res.message);
        }
      } catch (error) {
        console.error("请求错误:", error);
      } finally {
        loading.value = false;
      }
    };
    const types = ref(1);
    const cha_id = ref("");
    const from = ref("");
    const page_f = ref(1);
    const set_louts = async item => {
      let reqdata = {
        md5: item.md5,
        seq: item.seq
      };
      let res_pg = await getlocation_list(reqdata);
      if (res_pg.code == 0) {
        page_f.value = res_pg.data;
      }
      console.error(res_pg, "定位分页");
      if (item?.roomid) {
        let res = await getgroup_info({
          chat_id: item.roomid
        });
        item_chats.value = res.data;
        types.value = 2;
        cha_id.value = item.roomid;
        dialogVisible.value = true;
        return;
      } else {
        types.value = 1;
        if (item.user_type == 1) {
          from.value = item.tolist;
        }
        if (item.user_type == 2) {
          from.value = item.from;
        }
        cha_id.value = item.md5;
        item_chats.value = item;
        dialogVisible.value = true;
      }
    };
    const closeDialog = () => {
      dialogVisible.value = false;
    };
    return (_ctx, _cache) => {
      const _component_chatting = _resolveComponent("chatting");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(roleListTotal.value) + "条相关聊天记录", 1)]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data_list.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "chart_item",
          key: index,
          onMouseover: $event => item.hover = true,
          onMouseleave: $event => item.hover = false
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          class: "item_img",
          src: item.user_type === 1 && item.customer ? item.customer.avatar : _unref(item_user),
          alt: ""
        }, null, 8, _hoisted_7), _createElementVNode("span", _hoisted_8, _toDisplayString(item.user_type === 1 && item.customer && item.customer.name ? item.customer.name + "(" + item.customer.remark + ")" : item.user?.name || ""), 1), _createElementVNode("span", {
          class: _normalizeClass(["tag_item", item.user_type === 1 && item.customer ? 'tag_1' : 'tag_2'])
        }, _toDisplayString(item.user_type === 1 && item.customer ? "@微信" : "@" + item.user?.dept_name || ""), 3), _createElementVNode("span", _hoisted_9, _toDisplayString(item.msg_time), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
          class: "chat_text",
          innerHTML: get_message(item)
        }, null, 8, _hoisted_11), item.hover ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "lok_sdets",
          onClick: $event => set_louts(item)
        }, " 查看 > ", 8, _hoisted_12)) : _createCommentVNode("", true)])], 40, _hoisted_5);
      }), 128))]), _createVNode(protoPagination, {
        page: page.value,
        total: roleListTotal.value,
        onCurrentChange: handleRoleTableCurrentChange
      }, null, 8, ["page", "total"]), _createVNode(_component_el_dialog, {
        style: {
          "height": "80vh"
        },
        "model-value": dialogVisible.value,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog,
        top: "1vh",
        class: "pdialog"
      }, {
        default: _withCtx(() => [_createVNode(_component_chatting, {
          page_f: page_f.value,
          dialog_s: true,
          item_chats: item_chats.value,
          from: from.value,
          cha_id: cha_id.value,
          types: types.value
        }, null, 8, ["page_f", "item_chats", "from", "cha_id", "types"])]),
        _: 1
      }, 8, ["model-value"])])), [[_directive_loading, loading.value]]);
    };
  }
});